<template>
  <div>
    <ScribbleResponsive v-if="isResponsiveScribbleEnabled" v-bind="props" @style="onStyle" />
    <ScribbleOriginal v-else v-bind="props" @style="onStyle" />
  </div>
</template>
<script setup lang="ts">
import { computed, type ComputedRef, type CSSProperties, inject } from 'vue'

import ScribbleOriginal from './Scribble.original.vue'
import ScribbleResponsive from './Scribble.responsive.vue'
import { type ComponentNode, type ScribbleProps } from '@canvas-builder/types/canvas'
import { defaultWhenUsedInSection } from '@canvas-builder/constants'
import { type CanvasRetrieve } from '@openapi'
import type { LaunchDarklyEnv } from '@lib/types/launchDarkly.types'
import type { ComponentNodeThemeMeta } from '@canvas-builder/types/canvas'

const props = withDefaults(
  defineProps<{
    id: string
    data: ScribbleProps
    children?: ComponentNode[]
    usedInSectionId?: CanvasRetrieve['id']
    when_used_in_section?: ComponentNode['when_used_in_section']
    visible?: ComponentNode['visible']
    tracking_id?: string
    style?: CSSProperties
    theme_meta?: ComponentNodeThemeMeta
  }>(),
  {
    children: () => [],
    when_used_in_section: () => defaultWhenUsedInSection,
    usedInSectionId: '',
  },
)

const emit = defineEmits<{
  style: [s: CSSProperties, id?: ComponentNode['id']]
}>()

const launchDarkly = inject<ComputedRef<LaunchDarklyEnv>>(
  'launchDarkly',
  computed(() => ({})),
)

const isResponsiveScribbleEnabled = computed(() => !!launchDarkly.value.enable_responsive_scribble_component)

function onStyle(s: CSSProperties, id?: ComponentNode['id']) {
  emit('style', s, id)
}
</script>
